module.exports = __webpack_public_path__ + "assets/img/img_2013.d3d34d37.jpg";